/* eslint-disable @typescript-eslint/no-shadow */
import React, { useEffect, useState } from 'react';

import styles from 'src/app/components/Toolbox/Toolbox.module.scss';
import './style.scss';

import DraggableModal from 'src/app/components/DraggableModal/DraggableModal';
import CustomPopover from 'src/app/components/SharedComponents/CustomPopover';

import { useForm } from 'antd/es/form/Form';
import { BiHide } from 'react-icons/bi';

import { drawenLayerGroupHelper, statusHelper, modalHelper } from 'src/app/helpers';
import { errorLocals } from 'src/locals';
import {
  IProps,
  LocalFormDisplayMode as FormDisplayMode,
  headerDrawGroupTitles,
} from 'src/app/components/DrawGroupModal/draw-group-modal.config';
import { DrawenLayerGroupDataType, DrawenLayerGroupResultType } from 'src/types/components/draw-module.type';
import { drawenLayerGroupLayerService, drawenLayerGroupService, drawenLayerService } from 'src/app/services';
import { CopyOutlined } from '@ant-design/icons';
import { updateDrawName } from 'src/app/helpers/drawenLayer.helper';
import { displayWarning } from 'src/app/helpers/status.helper';
import SearchableSelect from 'src/app/components/SearchableSelect/SearchableSelect';
import { TransferItem } from 'antd/es/transfer';
import { Form, Switch, TransferProps, Typography } from 'antd/es';
import { useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { TaraflarLookupResultType } from 'src/types/services/hymotsc/taraflar.type';
import { urlsConfig } from 'src/configs';
import { hymotscCommonLookup } from 'src/app/services/hymotsc/common-lookup.service';

import { useTranslation } from 'react-i18next';
import Popconfirm from 'antd/es/popconfirm';
import Select from 'antd/es/select';
import Input from 'antd/es/input/Input';
import Table from 'antd/es/table/Table';
import Button from 'antd/es/button/button';

export default function DrawGroupModal({
  active,
  setActive,
  tarafId,
  drawController,
  drawGroups,
  setDrawGroups,
}: IProps & {
  drawGroups: DrawenLayerGroupResultType[];
  setDrawGroups: React.Dispatch<React.SetStateAction<DrawenLayerGroupResultType[]>>;
}) {
  const { t, i18n } = useTranslation();

  const defaultData: DrawenLayerGroupDataType = {
    id: 0,
    text: '',
    tarafId,
    isPrivate: false,
  };

  const [form] = useForm();

  const { hymotsDB } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { userName } = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const { usersList } = useSelector((state: reduxRootTypes.RootStateType) => state.userListState);

  const [dataInForm, setDataInForm] = useState<DrawenLayerGroupDataType>(defaultData);
  const [modalMode, setModalMode] = useState<FormDisplayMode>(FormDisplayMode.SHOW);
  const [displayModal, setDisplayModal] = useState<boolean>(false);
  const [activeGroupIds, setActiveGroupIds] = useState<number[]>([]);

  const [copyLayerName, setCopyLayerName] = useState<string>('');
  const [drawName, setDrawName] = useState<string>('');
  const [selectedGroups, setSelectedGroups] = useState<number[]>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
  const [isPrivateChecked, setIsPrivateChecked] = useState<boolean>(false);

  const [allTaraflar, setAlTaraflar] = useState<any>([]);
  const [transferData, setTransferData] = useState<TransferItem[]>([]);
  const [targetKeys, setTargetKeys] = useState<React.Key[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [filteredDrawGroups, setFilteredDrawGroups] = useState<DrawenLayerGroupResultType[]>([]);
  const [copyName, setCopyName] = useState<string>('');

  const [allPublishedLayers, setAllPublishedLayers] = useState<any>([]);
  const [existingTarafIds, setExistingTarafIds] = useState<number[]>([]);

  const [pagination, setPagination] = useState<{ current: number; pageSize: number }>({
    current: 1,
    pageSize: 5,
  });

  const getAgents = async () => {
    const { data: tarafData } = await hymotscCommonLookup<TaraflarLookupResultType>({
      blockSpinner: true,
      urlRoute: urlsConfig.generics.common.taraflar,
    });

    urlsConfig.generics.common.taraflar;
    setAlTaraflar(tarafData);
  };

  useEffect(() => {
    getAgents();
  }, []);

  useEffect(() => {
    let holder = drawGroups.map((group) => ({ ...group, key: group.id })) || [];

    if (allPublishedLayers && allPublishedLayers.length > 0 && tarafId) {
      const matchingPublishedLayers = allPublishedLayers.filter((layer: any) => layer.tarafId === tarafId);

      const additionalGroups = drawGroups
        .filter(
          (group) =>
            !holder.some((h) => h.id === group.id) &&
            matchingPublishedLayers.some((layer: any) => layer.drawenLayerGroupId === group.id),
        )
        .map((group) => ({ ...group, key: group.id }));

      holder = [...holder, ...additionalGroups];
    }

    holder.sort((a, b) => b.id - a.id);

    setFilteredDrawGroups(holder);
  }, [JSON.stringify(drawGroups), drawController?.drawGroups]);

  useEffect(() => {
    if (!allTaraflar?.rows) return;

    const items: TransferItem[] = allTaraflar.rows.map((etmen: any) => ({
      key: etmen.id.toString(),
      title: etmen.kisaIsim,
      fullname: etmen.kisaIsim,
      disabled: etmen.id === dataInForm.tarafId,
    }));

    setTransferData(items);
  }, [allTaraflar, dataInForm.tarafId, existingTarafIds]);

  // useEffect(() => {
  //   if (manageModal && dataInForm.id) {
  //     const currentGroup = drawGroups.find((group) => group.id === dataInForm.id);
  //     if (currentGroup) {
  //       getOneLayerGroupTaraf(dataInForm.id);
  //     }
  //   }
  // }, [drawGroups, manageModal, dataInForm.id]);

  const onChangeForTransfer: TransferProps<TransferItem>['onChange'] = (targetKeys) => {
    setTargetKeys(targetKeys);
  };

  const onTransferSelectChange: TransferProps<TransferItem>['onSelectChange'] = (
    sourceSelectedKeys,
    targetSelectedKeys,
  ) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const handleExpand = (expanded: boolean, record: any) => {
    setExpandedRowKeys((prevKeys) => {
      const filteredKeys = filteredDrawGroups.map((group) => group.id);
      const updatedKeys = expanded
        ? [...prevKeys, record.id].filter((key) => filteredKeys.includes(key))
        : prevKeys.filter((key) => key !== record.id);
      return updatedKeys;
    });
  };

  const socketOnGroupDelete = (id: number) => {
    drawController?.hideLayersByGroupId(id);
  };

  useEffect(() => {
    if (drawController) {
      setActiveGroupIds(Array.from(drawController.activeGroupIds));
      drawController.updateActiveLayersController();
    }
  }, [drawController]);

  useEffect(() => {
    if (drawController) {
      drawController.setDrawGroupsData(drawGroups);
    }
  }, [drawController, drawGroups]);

  const getData = async () => {
    const res = await drawenLayerGroupHelper.getDrawGroups(tarafId);
    if (res) {
      setDrawGroups(res.data);
      drawenLayerGroupHelper.createDrawGroupSocketConnection(
        setDrawGroups,
        drawGroups,
        socketOnGroupDelete,
        hymotsDB || 0,
        drawController,
        tarafId,
        'Controller',
      );
    }
  };

  useEffect(() => {
    if (hymotsDB && drawController) {
      getData();
    }
  }, [hymotsDB, tarafId, active, drawController]);

  useEffect(() => {
    if (drawController && drawGroups) {
      if (JSON.stringify(drawController.drawGroups) !== JSON.stringify(drawGroups)) {
        drawController.setDrawGroupsData(drawGroups);
      }
    }
  }, [drawController, drawGroups]);

  const handleDelete = async (deletedItem: DrawenLayerGroupDataType) => {
    try {
      if (deletedItem.id) {
        await drawenLayerGroupService.drawenLayerGroupDelete(deletedItem.id, tarafId ?? 0);
        socketOnGroupDelete(deletedItem.id);
        drawController?.deleteLayerGroupfromDrawGroups(deletedItem.id);
        setDrawGroups((current) => {
          const updatedGroups = current.filter((x) => x.id !== deletedItem.id);
          return current.filter((x) => updatedGroups.includes(x));
        });
        drawController?.setDrawGroupsData(drawGroups);

        if (deletedItem.id === dataInForm.id) {
          setDataInForm(defaultData);
          setDisplayModal(false);
        }
      }
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    }
  };

  const handleDeleteDraw = async (deletedItem: any) => {
    try {
      if (deletedItem?.key) {
        await drawenLayerGroupLayerService.destroyDrawenLayerGroupsLayer(
          tarafId ?? 0,
          deletedItem.drawenLayerGroupLayerData.drawenLayerGroupId,
          deletedItem.key,
        );

        if (drawController && deletedItem.uuid) {
          drawController.removeLayerByUUID(deletedItem.uuid, deletedItem.drawenLayerGroupLayerData.drawenLayerGroupId);
          drawController.drawControllerDeleteEvent(deletedItem.uuid);
        }

        if (deletedItem.key === dataInForm.id) {
          setDataInForm(defaultData);
          setDisplayModal(false);
          setDrawGroups((currentGroups) =>
            currentGroups.map((group) => {
              if (group.id === deletedItem.drawenLayerGroupLayerData.drawenLayerGroupId) {
                return {
                  ...group,
                  drawenLayers: group.drawenLayers.filter((layer) => layer.id !== deletedItem.key),
                };
              }
              return group;
            }),
          );
        }
      }
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    } finally {
      getData();

      if (drawController) {
        setActiveGroupIds(Array.from(drawController.activeGroupIds));
      }
    }
  };

  // update draw name
  const handleEditDraw = async (record: any) => {
    const drawGroup = drawGroups.find((group) => group.drawenLayers.some((layer) => layer.id === record.key));
    if (!drawGroup) {
      return displayWarning('Error: Related Draw Group not found!');
    }

    try {
      await updateDrawName(record.uuid, drawName !== '' ? drawName : record.shapeName);
      const updatedDataSource = drawGroups.map((group) => {
        if (group.id === drawGroup.id) {
          return {
            ...group,
            drawenLayers: group.drawenLayers.map((layer) =>
              layer.id === record.key
                ? {
                    ...layer,
                    name: drawName !== '' ? drawName : record.shapeName,
                    updatedAt: new Date().toISOString(),
                    updatedBy: userName,
                    feature: {
                      ...layer.features,
                      properties: {
                        ...layer.features?.properties,
                        name: drawName !== '' ? drawName : record.shapeName,
                      },
                    },
                  }
                : layer,
            ),
          };
        }

        return group;
      });
      setDrawGroups([...updatedDataSource]);
      setDrawName('');
    } catch (error) {
      statusHelper.displayErrorMessage(t('errors.unknownError'));
    }
  };

  // Copy Layer
  const onClickCopy = async (record: Partial<DrawenLayerGroupDataType> & { key: React.Key }) => {
    if (filteredDrawGroups.some((x) => x.text === copyLayerName)) {
      statusHelper.displayErrorMessage('Layer text must be different than others!');
      return;
    }

    try {
      const drawGroup = drawGroups.find((o) => o.id === record.id);
      if (drawGroup) {
        const { data: newDrawGroup } = await drawenLayerGroupService.drawenLayerGroupCopy(
          drawGroup.id,
          copyLayerName,
          tarafId || 0,
        );

        const originalIndex = drawGroups.findIndex((g) => g.id === record.id);

        setDrawGroups((current) => {
          const updatedGroups = [...current];
          updatedGroups.splice(originalIndex + 1, 0, newDrawGroup);
          return updatedGroups;
        });

        setCopyLayerName('');
        statusHelper.displaySuccessStatusMessage(t('success.layerCopied'));
      }
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    } finally {
      getData();
    }
  };

  // Copy Shape
  const handleCopyShape = async (shapeId: number, copyGroups: number[], names: string) => {
    try {
      const response = await drawenLayerService.drawenLayerCopy(shapeId, copyGroups, names, tarafId || 0);
      if (response) {
        statusHelper.displaySuccessStatusMessage(t('success.shapeCopied'));
      }
      setCopyName('');
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response?.data?.message || t('errors.unkownError'));
      }
    } finally {
      getData();
    }
  };

  const handleOnCloseModal = () => {
    setDisplayModal(false);
  };

  const handleCancel = () => {
    setDataInForm(defaultData);
    handleOnCloseModal();
  };

  const onFormSave = async (values: any) => {
    if (modalMode === FormDisplayMode.EDIT) {
      try {
        const updatedData = {
          ...dataInForm,
          text: values.text,
          isPrivate: isPrivateChecked,
        };

        const { data: updatedItem } = await drawenLayerGroupService.drawenLayerGroupEdit(updatedData);
        setDrawGroups((current) => {
          const index = current.findIndex((o) => o.id === updatedItem.id);
          const updatedGroups = [...current];
          updatedGroups[index] = updatedItem;
          return updatedGroups;
        });
        setDisplayModal(false);
        setDataInForm(defaultData);
        drawController?.updateActiveLayersController();
      } catch (error: any) {
        if (error !== errorLocals.errorHandledError) {
          console.log('error', error);
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    } else if (modalMode === FormDisplayMode.CREATE) {
      try {
        if (filteredDrawGroups.some((x) => x.text === dataInForm.text)) {
          statusHelper.displayErrorMessage('Layer text must be different than others');
        } else {
          const { data: newItem } = await drawenLayerGroupService.drawenLayerGroupCreate({
            ...dataInForm,
            isPrivate: isPrivateChecked,
          });
          setDrawGroups((current) => {
            if (current.some((o) => o.id === newItem.id)) {
              return current;
            }
            const updated = [...current, newItem];
            drawController?.setDrawGroupsData(updated);
            return updated;
          });
          setDisplayModal(false);
          setDataInForm(defaultData);
        }
      } catch (error: any) {
        if (error !== errorLocals.errorHandledError) {
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    }

    form.resetFields();
  };

  const onClickShowHide = async (
    record: Partial<DrawenLayerGroupDataType> & { key: React.Key },
    mode: 'hide' | 'show',
  ) => {
    // console.log('record', record);
    if (record.id && drawController) {
      const drawGroup = await drawenLayerGroupHelper.getDrawGroup(record.id);

      if (drawGroup && mode === 'show') {
        drawController?.showLayerGroupLayers(drawGroup.id, drawGroup.drawenLayers);
      }

      if (drawGroup && mode === 'hide') {
        drawController?.hideLayersByGroupId(drawGroup.id);
      }

      setActiveGroupIds(Array.from(drawController.activeGroupIds));
    }
  };

  const onClickEdit = (record: Partial<DrawenLayerGroupDataType> & { key: React.Key }) => {
    const drawGroup = drawGroups.find((o) => o.id === record.id);

    if (drawGroup) {
      setModalMode(FormDisplayMode.EDIT);
      setDataInForm({ ...drawGroup });
      setIsPrivateChecked(record.isPrivate || false);
      setDisplayModal(true);
    }
  };

  const shapesCustomColumns = [
    {
      title: t('hymotsc.drawTool.name'),
      dataIndex: 'shapeName',
      key: 'shapeName',
      render: (text: any) => (
        <div style={{ textAlign: 'center', width: '150px', maxHeight: '125px', overflow: 'auto' }}>{text || '-'}</div>
      ),
    },
    {
      title: t('hymotsc.drawTool.shapeType'),
      dataIndex: 'shapeType',
      key: 'shapeType',
      render: (_: any, record: any) => {
        const feature = record?.features || record?.feature;
        const geometry = feature?.geometry;
        const type = geometry?.type;
        let label = '-';
        if (type === 'Point') {
          if (feature?.properties?.radius === 10) {
            label = 'Circle Marker';
          } else if (feature?.properties?.radius) {
            label = 'Circle';
          } else if (feature?.properties?.fontSize) {
            label = 'Text';
          } else {
            label = 'Point Marker';
          }
        } else if (type === 'LineString') {
          label = 'Line';
        } else if (type === 'Polygon') {
          label = 'Polygon';
        }

        return <div style={{ textAlign: 'center' }}>{label}</div>;
      },
    },
    {
      title: t('hymotsc.drawTool.coordinates'),
      dataIndex: 'coordinates',
      key: 'coordinates',
      render: (text: any) => (
        <div
          style={{
            minWidth: '220px',
            width: '220px',
            maxHeight: '125px',
            overflow: 'auto',
            textAlign: 'center',
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: t('hymotsc.drawTool.createdBy'),
      dataIndex: 'createdBy',
      key: 'createdBy',
      render: (text: any) => <div style={{ textAlign: 'center', width: '130px' }}>{text || '-'}</div>,
    },
    {
      title: t('hymotsc.drawTool.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text: any) => <div style={{ textAlign: 'center', maxWidth: '100px' }}>{text || '-'}</div>,
    },
    {
      title: t('hymotsc.drawTool.updatedBy'),
      dataIndex: 'updatedBy',
      key: 'updatedBy',
      render: (text: any) => <div style={{ textAlign: 'center', width: '130px' }}>{text || '-'}</div>,
    },
    {
      title: t('hymotsc.drawTool.updatedAt'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text: any) => <div style={{ textAlign: 'center', maxWidth: '100px' }}>{text || '-'}</div>,
    },
    {
      // copy, edit, delete
      title: t('hymotsc.tableOperations.operations'),
      dataIndex: 'Actions',
      width: '20%',
      render: (_: any, record: any) => {
        return (
          <div className="draw-tool-operations-buttons" style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ marginRight: '10px', marginTop: '2.5px' }}>
              <CustomPopover content={<div>{t('hymotsc.drawTool.bringToFront')}</div>} trigger="hover">
                <Popconfirm
                  style={{ width: '250px' }}
                  title={t('hymotsc.drawTool.bringFrontShape')}
                  okText={t('hymotsc.drawTool.confirm')}
                  cancelText={t('hymotsc.drawTool.cancel')}
                  onConfirm={async () => {
                    await handleEditDraw(record);
                  }}
                >
                  <svg
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#ffffff"
                    transform="matrix(1, 0, 0, -1, 0, 0)"
                    style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                    <g id="SVGRepo_iconCarrier">
                      <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z" />{' '}
                    </g>
                  </svg>
                </Popconfirm>
              </CustomPopover>
            </div>
            <CustomPopover content={<div>{t('hymotsc.drawTool.copyShape')}</div>} trigger="hover">
              <Popconfirm
                title={
                  <div style={{ display: 'flex', flexDirection: 'column', width: '250px' }}>
                    <span className="">{t('hymotsc.drawTool.selectLayer')}</span>
                    <SearchableSelect
                      notSorted
                      onChange={(e) => {
                        setSelectedGroups(e);
                      }}
                      size="middle"
                      mode="multiple"
                      allowClear
                      maxTagCount={3}
                      style={{ border: '1px solid #4f4f4f' }}
                    >
                      {drawGroups.map((o) => (
                        <Select.Option key={o.id} value={o.id}>
                          {o.text}
                        </Select.Option>
                      ))}
                    </SearchableSelect>
                    <span style={{ paddingTop: '8px' }}>{t('hymotsc.drawTool.enterName')}</span>
                    <Input
                      onChange={(e) => setCopyName(e.target.value)}
                      placeholder={t('hymotsc.drawTool.newShapeName') || ''}
                      maxLength={50}
                      style={{ width: '250px' }}
                    />
                  </div>
                }
                onConfirm={() => handleCopyShape(record.key, selectedGroups, copyName)}
                okButtonProps={{
                  disabled: !selectedGroups.length,
                }}
                cancelText={t('hymotsc.drawTool.cancel')}
                okText={t('hymotsc.drawTool.confirm')}
                placement="topRight"
              >
                <Typography.Link>
                  <CopyOutlined style={{ fontSize: 20, marginTop: 2, marginRight: 1.5 }} />
                </Typography.Link>
              </Popconfirm>
            </CustomPopover>
            <CustomPopover content={<div>{t('hymotsc.tableOperations.edit')}</div>} trigger="hover">
              <Popconfirm
                title={
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>{t('hymotsc.drawTool.enterNewNameForDraw')}</span>
                    <Input
                      style={{ width: '250px' }}
                      onChange={(e) => setDrawName(e.target.value)}
                      placeholder={t('hymotsc.drawTool.newLayerName') || ''}
                      maxLength={50}
                      defaultValue={record.shapeName}
                    />
                  </div>
                }
                onConfirm={async () => {
                  await handleEditDraw(record);
                }}
                okButtonProps={{
                  disabled: !drawName.trim() || drawName.trim() === record.shapeName.trim(),
                }}
                cancelText={t('hymotsc.drawTool.cancel')}
                okText={t('hymotsc.drawTool.confirm')}
                placement="bottom"
              >
                <img
                  className="edit-icon"
                  src="/assets/editIcon.png"
                  alt="edit"
                  style={{
                    marginTop: '1px',
                  }}
                />
              </Popconfirm>
            </CustomPopover>
            <CustomPopover content={<div>{t('hymotsc.tableOperations.delete')}</div>} trigger="hover">
              <Popconfirm
                placement="bottom"
                title={t('hymotsc.drawTool.deleteLayers')}
                okText={t('hymotsc.drawTool.confirm')}
                cancelText={t('hymotsc.drawTool.cancel')}
                icon=""
                onConfirm={() => handleDeleteDraw(record)}
              >
                <img className="delete-icon" src="/assets/deleteIcon.png" alt="delete" />
              </Popconfirm>
            </CustomPopover>
          </div>
        );
      },
    },
  ];

  const customColumns = [
    {
      title: t('hymotsc.tableColumns.groupName'),
      dataIndex: 'Text',
      width: '25%',
      render: (_: any, record: any) => <div style={{ textAlign: 'center' }}>{record?.text}</div>,
    },
    {
      title: t('hymotsc.tableColumns.side'),
      dataIndex: 'Taraf',
      width: '15%',

      render: (_: any, record: any) => {
        const taraf = allTaraflar.rows.find((o: any) => o.id === record.tarafId);
        return <div style={{ textAlign: 'center' }}>{taraf ? taraf.kisaIsim : 'Controller'}</div>;
      },
    },
    {
      title: t('hymotsc.tableColumns.privateSettings'),
      dataIndex: 'isPrivate',
      width: '20%',
      render: (_: any, record: any) => (
        <div style={{ textAlign: 'center' }}>
          <Switch
            style={{ width: '100px' }}
            className="custom-switch"
            checkedChildren={t('hymotsc.drawTool.private')}
            unCheckedChildren={t('hymotsc.drawTool.public')}
            checked={record?.isPrivate}
            onChange={async (checked) => {
              try {
                const updatedData = { ...record, isPrivate: checked };
                await drawenLayerGroupService.drawenLayerGroupEdit(updatedData);
                setDrawGroups((current) =>
                  current.map((group) => (group.id === record.id ? { ...group, isPrivate: checked } : group)),
                );
                statusHelper.displaySuccessStatusMessage(t('hymotsc.drawTool.layerGroupUpdated'));
              } catch (error: any) {
                statusHelper.displayErrorMessage(error.response?.data?.message || t('errors.unkownError'));
              }
            }}
          />
        </div>
      ),
    },

    {
      title: t('hymotsc.tableOperations.operations'),
      width: '30%',
      dataIndex: 'Actions',
      render: (_: any, record: any) => {
        const isActive = activeGroupIds.includes(record.id);
        const mode = isActive ? 'hide' : 'show';
        const icon = isActive ? (
          <BiHide style={{ verticalAlign: 'middle' }} size={22} />
        ) : (
          <img className="more-icon" src="/assets/moreIcon.png" alt="more" />
        );
        const tooltipText = isActive ? t('hymotsc.drawTool.hideLayers') : t('hymotsc.drawTool.showLayers');

        return (
          <div className="draw-tool-operations-buttons" style={{ display: 'flex', justifyContent: 'center' }}>
            <CustomPopover content={<div>{tooltipText}</div>} trigger="hover">
              <Typography.Link onClick={() => onClickShowHide(record, mode)}>{icon}</Typography.Link>
            </CustomPopover>
            <CustomPopover content={<div>{t('hymotsc.drawTool.copyLayer')}</div>} trigger="hover">
              <Popconfirm
                title={
                  <div>
                    <span>{t('hymotsc.drawTool.enterNewNameForCoppiedLayer')}r:</span>
                    <Input
                      onChange={(e) => setCopyLayerName(e.target.value)}
                      placeholder={t('hymotsc.drawTool.newLayerName') || ''}
                    />
                  </div>
                }
                onConfirm={() => onClickCopy(record)}
                okButtonProps={{
                  disabled: !copyLayerName.trim(),
                }}
                cancelText={t('hymotsc.drawTool.cancel')}
                okText={t('hymotsc.drawTool.confirm')}
                placement="topRight"
              >
                <div>
                  <CopyOutlined style={{ fontSize: '20px', marginTop: 2, cursor: 'pointer' }} />
                </div>
              </Popconfirm>
            </CustomPopover>
            <CustomPopover content={<div>{t('hymotsc.tableOperations.edit')}</div>} trigger="hover">
              <Typography.Link onClick={() => onClickEdit(record)}>
                <img className="edit-icon" src="/assets/editIcon.png" alt="edit" />
              </Typography.Link>
            </CustomPopover>
            <CustomPopover content={<div>{t('hymotsc.tableOperations.delete')}</div>} trigger="hover">
              <Popconfirm
                placement="bottom"
                title={t('hymotsc.drawTool.deleteGroup')}
                okText={t('hymotsc.drawTool.confirm')}
                cancelText={t('hymotsc.drawTool.cancel')}
                icon=""
                onConfirm={() => handleDelete(record)}
              >
                <img className="delete-icon" src="/assets/deleteIcon.png" alt="delete" />
              </Popconfirm>
            </CustomPopover>
          </div>
        );
      },
    },
  ];

  const findNameById = (id: number) => {
    const name = usersList.find((user) => user.id === id.toString());
    return name ? name.userName : '-';
  };

  const expandedRowRender = (record: any) => {
    const sortedLayers = record.drawenLayers.sort((a: any, b: any) => {
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    });
    return (
      <div style={{ overflowY: 'auto', maxHeight: '300px', borderTop: '1px solid #4f4f4f' }}>
        {record.drawenLayers ? (
          <Table
            columns={shapesCustomColumns}
            dataSource={sortedLayers.map((layer: any) => ({
              drawenLayerGroupLayerData: layer.Drawen_Layer_Group_Layer,
              uuid: layer.uuid,
              key: layer.id,
              shapeName: layer.name ?? '-',
              shapeType: layer.features?.geometry?.type ?? '-',
              coordinates: JSON.stringify(layer.features?.geometry?.coordinates ?? []),
              createdBy: layer.createdBy ?? findNameById(layer.createdById) ?? '-',
              createdAt: layer.createdAt ? new Date(layer.createdAt).toLocaleString() : '-',
              updatedAt: layer.updatedAt ? new Date(layer.updatedAt).toLocaleString() : '-',
              updatedBy: layer.updatedBy ?? findNameById(layer.updatedById) ?? '-',
              features: layer.features,
            }))}
            pagination={false}
            bordered
            style={{
              overflowX: 'hidden',
            }}
          />
        ) : (
          <div>No layers available for this group</div>
        )}
      </div>
    );
  };

  const onFormChange = (inputLabel: keyof DrawenLayerGroupDataType, value: any) => {
    setDataInForm({
      ...dataInForm,
      [inputLabel]: value,
      isPrivate: isPrivateChecked,
    });
  };

  const onClickAdd = () => {
    setDataInForm(defaultData);
    setDisplayModal(true);
    setModalMode(FormDisplayMode.CREATE);
    setIsPrivateChecked(false);
  };

  if (!active) return null;

  // const getOneLayerGroupTaraf = async (layerId: number) => {
  //   try {
  //     const { data: layerGroupTaraf } = await drawenLayerGroupTarafService.getOneLayerGroupTaraf(layerId);

  //     // If we're looking at the currently selected group, update the UI
  //     if (dataInForm.id === layerId) {
  //       // pull out just the tarafIds
  //       const selectedIds = layerGroupTaraf.map((item) => item.tarafId);
  //       setExistingTarafIds(selectedIds);

  //       const keysAsString = selectedIds.map((id) => id.toString());
  //       setTargetKeys(keysAsString);
  //       setSelectedKeys(keysAsString);
  //     }
  //   } catch (error: any) {
  //     if (error !== errorLocals.errorHandledError) {
  //       statusHelper.displayErrorMessage(error.response.data.message);
  //     }
  //   }
  // };

  // exportDrawGroups to json
  // const exportDrawGroups = async () => {
  //   try {
  //     const jsonData = JSON.stringify(drawGroups, null, 2);
  //     const blob = new Blob([jsonData], { type: 'application/json' });
  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `drawGroups_${new Date().toISOString()}.json`;
  //     a.click();
  //     URL.revokeObjectURL(url);
  //   } catch (error) {
  //     statusHelper.displayErrorMessage('Failed to export draw groups');
  //   }
  // };

  const modalDefaultPosition = i18n.dir() === 'rtl' ? { x: -200, y: 20 } : { x: 200, y: 70 };

  return (
    active && (
      <DraggableModal
        headerText={t('hymotsc.drawTool.layerAction')}
        className={styles.drawLayerDrag}
        contentClassName="layer-action-content"
        defaultPosition={modalDefaultPosition}
        onClickClose={() => setActive(false)}
        id="draw-group-modal"
      >
        {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}> */}
        {/* export import buttons */}
        {/* <div style={{ display: 'flex', gap: '10px', margin: '10px 0 0px 10px' }}>
            <Button
              title="Export"
              icon={<DownloadOutlined />}
              onClick={async () => {
                exportDrawGroups();
              }}
            />
            <Upload className="overlay-button">
              <Button title="Import" icon={<ImportOutlined />} />
            </Upload>
          </div> */}
        <Button
          style={{ margin: '10px 16px 0px 0px' }}
          className="next-button"
          onClick={() => {
            onClickAdd();
          }}
        >
          {t('hymotsc.drawTool.addNewLayer')}
        </Button>
        {/* </div> */}

        <Table
          scroll={{ x: '100vh' }}
          bordered
          columns={customColumns}
          dataSource={filteredDrawGroups}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '50'],
            onChange: (page, size) => {
              setPagination({ current: page, pageSize: size });
            },
          }}
          expandable={{
            expandedRowRender,
            expandedRowKeys,
            onExpand: handleExpand,
          }}
          style={{
            padding: '0 1rem',
            margin: '0 auto',
            width: '100%',
          }}
        />

        {displayModal && (
          <DraggableModal
            headerText={modalHelper.modalTitle(modalMode, headerDrawGroupTitles())}
            className={styles.dragInner}
            contentClassName={styles.dragContent}
            defaultPosition={{ x: -300, y: -15 }}
            onClickClose={() => {
              setDisplayModal(false);
              setDataInForm(defaultData);
            }}
            style={{
              resize: 'none',
            }}
            id="drawGroupsModal"
          >
            <Form initialValues={{ text: dataInForm.text }} form={form}>
              <div className="popup-main-container" style={{ width: '30rem', height: '14rem' }}>
                <div
                  className="popup-container"
                  style={{
                    overflow: 'hidden',
                  }}
                >
                  <div className="popup-content">
                    <div className={styles.container}>
                      <div className="popup-row grid-col-1-fixed">
                        <Form.Item name="text" rules={[{ required: true, message: t('general.required') || '' }]}>
                          <div className="popup-input-container">
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span className="popup-input-title">{t('hymotsc.drawTool.name')}</span>
                            </div>

                            <Input
                              value={dataInForm.text}
                              onChange={(e) => onFormChange('text', e.target.value)}
                              className="standard_input"
                            />
                          </div>
                        </Form.Item>
                      </div>

                      <div className="popup-row grid-col-1-fixed">
                        <Form.Item name="isPrivate" valuePropName="checked" style={{ marginBottom: 0 }}>
                          <div className="popup-input-container">
                            <div style={{ display: 'flex' }}>
                              <span className="popup-input-title">{t('hymotsc.drawTool.visibility')}</span>
                              <Switch
                                className="custom-switch"
                                checkedChildren={t('hymotsc.drawTool.private')}
                                unCheckedChildren={t('hymotsc.drawTool.public')}
                                checked={isPrivateChecked}
                                onChange={(checked) => {
                                  setIsPrivateChecked(checked);
                                  onFormChange('isPrivate', checked);
                                }}
                              />
                            </div>
                          </div>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>

                {modalMode !== FormDisplayMode.SHOW && (
                  <div className="popup-footer">
                    <div>
                      <button
                        className="next-button"
                        // Changing onClick to onFormSave leads to a bug where the modal closes before the form is submitted
                        onClick={(e) => {
                          e.preventDefault();
                          onFormSave(form.getFieldsValue());
                        }}
                      >
                        {t('general.save')}
                      </button>
                      <button className="modal-button" onClick={handleCancel} type="button">
                        {t('general.cancel')}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </Form>
          </DraggableModal>
        )}
      </DraggableModal>
    )
  );
}
